import Decimal from 'decimal.js';

export const parseFloatWithPrecision = (val?: string): Decimal => {
  if (!val) return Decimal(0);
  return new Decimal(val);
};
